import { IStoryData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IDetailResponse } from './eventDetail';
import eventSearch from './eventSearch';
import { IContentItemEvent } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { SEX_TYPE } from '../constants/category';

export interface EventData extends IDetailResponse, IStoryData {
  ImgUrl?: string;
  EventHostedBy?: string;
  EventInterestExpressed?: boolean;
  EventInterestCount?: number;
  AgeRange?: {
    AgeTo: number;
    AgeFrom: number;
  };
  EventAgeStart?: number;
  EventAgeEnd?: number;
  EventGuestTypes?: number;
  EventIsUserMatching?: boolean;
}

export default class Event {
  id: number;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  imgUrl: string;
  eventHostedBy: string;
  dateCreated: number | string | undefined;
  hasExpressInterest: boolean;
  interestCount: number;
  dateHeld: string;
  location: string;
  guestType: any[];
  ageMax: number;
  ageMin: number;
  isUserMatching: boolean;
  constructor() {
    this.id = -1;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.imgUrl = '';
    this.eventHostedBy = '';
    this.dateCreated = '';
    this.hasExpressInterest = false;
    this.interestCount = 0;
    this.dateHeld = '';
    this.location = '';
    this.guestType = [];
    this.ageMax = 0;
    this.ageMin = 0;
    this.isUserMatching = false;
  }

  static mappingObject(_obj: EventData): IContentItemEvent {
    let obj = Object.assign(new Event(), _obj);
    let text = Object.keys(SEX_TYPE).find(key => SEX_TYPE[key as keyof typeof SEX_TYPE] === String(_obj.EventGuestTypes)) || '';
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.imgUrl = _obj.ImgUrl ? _obj.ImgUrl : '';
    obj.eventHostedBy = _obj.EventHostedBy ? _obj.EventHostedBy : '';
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.hasExpressInterest = !!_obj.EventInterestExpressed;
    obj.interestCount = _obj.EventInterestCount ? _obj.EventInterestCount : 0;
    obj.dateHeld = _obj.DateHeld ? _obj.DateHeld : '';
    obj.location = _obj.Location ? _obj.Location : '';
    obj.guestType = _obj.GuestTypes
      ? _obj.GuestTypes.map(item => eventSearch.mappingObjectCategory(item))
      : _obj.MemberTypeList
        ? _obj.MemberTypeList.map(item => eventSearch.mappingObjectCategory(item))
        : _obj.EventGuestTypes
          ? [
              {
                value: _obj.EventGuestTypes,
                text: text
                  .toLowerCase()
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, c => c.toUpperCase()),
                isMatch: false,
              },
            ]
          : [];
    obj.ageMax = _obj.AgeRange ? _obj.AgeRange.AgeTo : _obj.EventAgeEnd ? _obj.EventAgeEnd : 0;
    obj.ageMin = _obj.AgeRange ? _obj.AgeRange.AgeFrom : _obj.EventAgeStart ? _obj.EventAgeStart : 0;
    obj.isUserMatching = _obj.EventIsUserMatching ? _obj.EventIsUserMatching : false;
    obj = utils.cleanObjectKeys(Object.keys(new Event()), obj);

    return obj;
  }

  static mappingObjects(_data: EventData[]): IContentItemEvent[] {
    return _data.map(item => Event.mappingObject(item));
  }
}
